import { actionCopyDe } from "./actionCopy";

export const analyticsCopyDe = {
    navTitle: "Analysen",
    navDescription: "Analysieren Sie die Daten Ihrer Patienten",
    events: "Ereignisse",
    outcomes: "Ergebnisse",
    rawData: "Rohdaten",
    searchPatientsPlaceholder: "Patienten suchen…",
    searchPatientsAria: "Patienten nach Name oder anderen Feldern suchen",
    clearPatientSearchAria: "Patientensuche löschen",
    editWithAiPlaceholder: "Mit KI bearbeiten",
    editWithAiAria: "Mit KI bearbeiten",
    stopAiEditAria: "KI anhalten",
    downloadCsv: "CSV herunterladen",
    preparingCsv: "CSV wird vorbereitet…",
    downloadSas: "Für SAS exportieren",
    preparingSas: "SAS wird vorbereitet…",
    sasExportHelp:
        "Laden Sie Ihre Analysedaten für SAS herunter. Studie und Zeitraum sind optional: Leer lassen, um alles zu exportieren, was Sie sehen können. Spalten verwenden Variablen-OIDs und kodierte Antworten oder den Fragetext, wenn ein Formular noch keine OIDs hat.",
    sasStudy: "Studie",
    sasFrom: "Von",
    sasTo: "Bis",
    sasExport: "Exportieren",
    sasDateOrder: "Das Startdatum muss vor dem Enddatum liegen oder dem Enddatum entsprechen.",
    sasFailed: "Der SAS-Export ist fehlgeschlagen. Versuchen Sie es erneut.",
    sasForbidden: "Sie haben keine Berechtigung, diese Studie zu exportieren.",
    sasUnmapped: "Für diese Auswahl gibt es keine Fragen zum Exportieren.",
    sasEmpty: "Keine Einträge für diese Studie und diesen Zeitraum.",
    sasRetry: "Erneut versuchen",
    sasAllStudies: "Alle Studien",
    sasAnyDate: "Beliebiges Datum",
    sasClearDate: (label: string) => `Datum „${label}“ löschen`,
    sasProgress: (loaded: number, total: number) => `Tagebücher werden geladen: ${loaded} von ${total}`,
    columns: actionCopyDe.columns,
    columnVisibilityDiffers: "Spaltenansicht weicht vom Standard ab",
    filter: actionCopyDe.filter,
    addFilter: "Filter hinzufügen",
    filtersFor: (name: string) => `Filter für „${name}“`,
    activeFilters: (count: number) => `${count} aktive Filter`,
    edit: actionCopyDe.edit,
    done: actionCopyDe.done,
    shared: "Geteilt",
    noData: "Keine Daten",
    noScoresForFilter: "Keine Werte für diese Filterkombination",
    failedToLoadEvents: "Ereignisse konnten nicht geladen werden",
    noEvents: "Keine Ereignisse",
    patients: "Patienten",
    gender: "Geschlecht",
    age: "Alter",
    area: "Bereich",
    diaryId: "Tagebuch-ID",
    patient: "Patient",
    date: "Datum",
    optionsFor: (name: string) => `Optionen für ${name}`,
    shiftLeft: "Nach links",
    pieChart: "Kreisdiagramm",
    donutChart: "Ringdiagramm",
    barChart: "Balkendiagramm",
    lineChart: "Liniendiagramm",
    sparkCharts: "Spark-Diagramme",
    statsTable: "Statistiktabelle",
    statsTableSpark: "Statistiktabelle + Spark-Diagramm",
    table: "Tabelle",
    stats: "Statistiken",
    timepointTable: "Zeitpunkt-Tabelle",
    histogram: "Histogramm",
    outliers: "Ausreißer",
    changeFromBaseline: "Änderung gegenüber Baseline",
    cumulativeEnrolment: "Kumulative Einschreibung",
    engagementRate: "Vollständigkeit unter den Begonnenen",
    followUpCompletion: "Nachbeobachtungs-Vollständigkeit",
    engagementHint:
        "Anteil der begonnenen Tagebücher, die jede Nachbeobachtung abgeschlossen haben. Die Baseline ist der erste Fragebogen und sollte nahe an der Tagebuch-Startrate liegen. Ein später Abschluss zählt als abgeschlossen. Nie begonnene Tagebücher und offene Fenster zählen nicht.",
    engagementPercentCompleted: "Prozent abgeschlossen",
    engagementRateHint:
        "Von den Patienten, die den Fragebogen begonnen haben: innerhalb eines Monats vollständig, innerhalb eines Monats nur teilweise, oder nicht innerhalb eines Monats abgeschlossen. Nie begonnene Patienten zählen nicht.",
    engagementComplete: "Vollständig innerhalb 1 Monat",
    engagementPartial: "Teilweise innerhalb 1 Monat",
    engagementNotStarted: "Nicht begonnen",
    engagementNotWithin: "Nicht innerhalb 1 Monat",
    engagementDue: "Fällig",
    engagementStarted: "Begonnen",
    engagementOfPatientsDue: "Prozent der fälligen Patienten",
    engagementOfPatientsStarted: "Prozent der Patienten, die begonnen haben",
    engagementOfDue: (completed: number, due: number) => `${completed} von ${due} fällig`,
    engagementLate: "Verspätet",
    engagementMissed: "Versäumt",
    engagementCompletion: "Vollständigkeit",
    engagementAllPatients: "Alle Patienten",
    engagementPatientsDue: (n: number) => `${n} fällig`,
    engagementHeatmapSplitHint:
        'Wählen Sie "Split by" in den Diagrammeinstellungen, um Standorte, Labels oder Behandler zu vergleichen.',
    engagementDotSize: "Die Punktgröße zeigt, wie viele Patienten fällig waren.",
    engagementDispositionHint:
        "Jeder Patient zählt einmal pro klinischem Zeitfenster. Offene Nachbeobachtungen zählen erst nach Abschluss oder Schließung des erlaubten Fensters.",
    engagementTimingHint:
        "Tage zwischen dem Absenden und dem geplanten Zeitpunkt. Der Punkt ist die Median-Differenz, der Balken die mittleren 50 %.",
    engagementTimingRangeHint:
        "Null ist der geplante Zeitpunkt. Eine positive Zahl ist Tage zu spät, eine negative Zahl Tage zu früh. Pünktlich bedeutet innerhalb des erlaubten Fensters auf beiden Seiten dieses Zeitpunkts: der Abstand bis zur nächsten Nachbeobachtung, von 1 Tag bis zu 21 Tagen.",
    engagementOnTimeCount: (onTime: number, completed: number) => `${onTime} von ${completed} pünktlich`,
    engagementTimingWindowColumn: "Erlaubtes Fenster",
    engagementDayWindow: (min: number, max: number) =>
        min === max ? `${min}-Tage-Fenster` : `${min}- bis ${max}-Tage-Fenster`,
    engagementTimingWindowSummary: (min: number, max: number) =>
        min === max ? `Innerhalb eines ${min}-Tage-Fensters` : `Innerhalb eines ${min}- bis ${max}-Tage-Fensters`,
    engagementWithinWindowCount: (onTime: number, completed: number, min: number, max: number) =>
        min === max
            ? `${onTime} von ${completed} innerhalb eines ${min}-Tage-Fensters`
            : `${onTime} von ${completed} innerhalb eines ${min}- bis ${max}-Tage-Fensters`,
    engagementOutsideDayWindow: (n: number, min: number, max: number) =>
        min === max ? `${n} außerhalb des ${min}-Tage-Fensters` : `${n} außerhalb des ${min}- bis ${max}-Tage-Fensters`,
    engagementOutsideWindow: (n: number, window?: string) =>
        window ? `${n} außerhalb des Fensters (${window})` : `${n} außerhalb des Fensters`,
    engagementWindowDays: (min: number, max: number) =>
        min === max ? `±${min} ${min === 1 ? "Tag" : "Tage"}` : `±${min} bis ${max} Tage`,
    engagementOutsideWindowColumn: "Außerhalb des Fensters",
    engagementGapDays: (days: number) => {
        const rounded = Math.round(days * 10) / 10;
        const unit = Math.abs(rounded) === 1 ? "Tag" : "Tage";
        if (rounded === 0) return `0 ${unit}`;
        return `${rounded > 0 ? "+" : ""}${rounded} ${unit}`;
    },
    engagementTimingAxisDays: (days: number) => {
        if (days === 0) return "0";
        const unit = Math.abs(days) === 1 ? "Tag" : "Tage";
        return `${days > 0 ? "+" : ""}${days} ${unit}`;
    },
    engagementTimingEmpty: "Keine abgeschlossenen geplanten Nachbeobachtungen mit Zeitdaten",
    engagementEarlier: "Früher",
    engagementScheduled: "Geplant",
    engagementLater: "Später",
    engagementMedian: "Median",
    engagementCompleted: "Abgeschlossen",
    engagementMiddle50: "Mittlere 50%",
    engagementCompletedCount: (n: number) => `${n} abgeschlossen`,
    engagementMetrics: "Engagement-Kennzahlen",
    engagementMetricsHint:
        "Eintrags- und Tagebuch-Abschluss verwenden Patientenfragebögen in begonnenen Tagebüchern. Der Tagebuch-Abschluss wird aus den begonnenen Tagebüchern gezählt. Fragebögen für Kliniker zählen nicht.",
    engagementMetric: "Kennzahl",
    engagementRateColumn: "Rate",
    engagementCount: "Anzahl",
    engagementOnTimeRate: "Pünktlichkeitsrate",
    engagementDiaryStartRate: "Tagebuch-Startrate",
    engagementEntryCompletionRate: "Eintrags-Abschlussrate",
    engagementDiaryCompletionRate: "Tagebuch-Abschlussrate",
    engagementDiariesStarted: (completed: number, due: number) => `${completed} von ${due} Tagebüchern begonnen`,
    engagementEntriesCompleted: (completed: number, due: number) => `${completed} von ${due} Einträgen abgeschlossen`,
    engagementDiariesCompleted: (completed: number, due: number) => `${completed} von ${due} Tagebüchern abgeschlossen`,
    engagementWindows: {
        baseline: "Baseline",
        w6: "Bis 6 Wochen",
        m3: "6 Wochen bis 3 Monate",
        m6: "3 bis 6 Monate",
        m12: "6 bis 12 Monate",
        m12plus: "Über 12 Monate",
    } as Record<string, string>,
    engagementAllCompleted: "Vollständig ausgefüllt",
    engagementSomeCompleted: "Teilweise ausgefüllt",
    engagementNoneStarted: "Noch keine Nachbeobachtung begonnen",
    engagementOnTime: "Pünktlich",
    engagementUnderMonth: "Weniger als 1 Monat zu spät",
    engagementOverMonth: "Mehr als 1 Monat zu spät",
    engagementEmpty: "Noch keine geplanten Nachbeobachtungen fällig",
    engagementPatient: "Patient",
    engagementClinician: "Behandler",
    engagementCohort: "Kohorte",
    engagementByLabel: "Tagebuch-Label",
    engagementByClinician: "Behandler",
    engagementByTracker: "Fragebogen",
    engagementFollowUp: "Nachbeobachtung",
    engagementFollowUpGrain: "Zeitpunkt",
    engagementFollowUpAbsolute: "Absolut",
    engagementFollowUpGrouped: "Gruppiert",
    engagementFollowUpDaily: "Täglich",
    engagementFollowUpWeekly: "Wöchentlich",
    engagementFollowUpMonthly: "Monatlich",
    engagementFollowUpQuarterly: "Vierteljährlich",
    engagementFollowUpYearly: "Jährlich",
    engagementFollowUpDays: "Tage",
    engagementFollowUpWeeks: "Wochen",
    engagementFollowUpMonths: "Monate",
    engagementFollowUpYears: "Jahre",
    engagementFollowUpAbsoluteHint: "Jede Nachuntersuchung bleibt ein eigener Punkt, in der Reihenfolge des Plans.",
    engagementFollowUpGroupedHint: "Gruppiert zeigt Monat 0, Monat 1, Monat 2. Monat 0 sind die ersten 30 Tage.",
    engagementFollowUpStep: (grain: "day" | "week" | "month" | "quarter" | "year", index: number) => {
        const label =
            grain === "day"
                ? "Tag"
                : grain === "week"
                  ? "Woche"
                  : grain === "month"
                    ? "Monat"
                    : grain === "quarter"
                      ? "Quartal"
                      : "Jahr";
        return `${label} ${index}`;
    },
    engagementFollowUpGrainHint: (grain: "day" | "week" | "month" | "quarter" | "year") => {
        if (grain === "day") return "Täglich zeigt Tag 0, Tag 1, Tag 2. Tag 0 ist der Eingriffstag.";
        if (grain === "week") return "Wöchentlich zeigt Woche 0, Woche 1, Woche 2. Woche 0 sind die ersten 7 Tage.";
        if (grain === "quarter")
            return "Vierteljährlich zeigt Quartal 0, Quartal 1, Quartal 2. Quartal 0 sind die ersten 90 Tage.";
        if (grain === "year") return "Jährlich zeigt Jahr 0, Jahr 1, Jahr 2. Jahr 0 ist das erste Jahr.";
        return "Monatlich zeigt Monat 0, Monat 1, Monat 2. Monat 0 sind die ersten 30 Tage.";
    },
    engagementGroupAria: "Teilnahme nach",
    engagementOf: (completed: number, due: number) => `${completed} von ${due}`,
    unlabelled: "Ohne Label",
    unassigned: "Nicht zugeordnet",
    timepoint: "Zeitpunkt",
    ageBracket: "Altersgruppe",
    label: "Tagebuch-Label",
    sex: "Geschlecht",
    anatomicArea: "Anatomisches Areal",
    event: "Ereignis",
    form: "Fragebogen",
    averageAge: "Durchschnittsalter",
    patientCountsByAgeBracket: "Patientenzahlen nach Altersgruppe",
    ageDistribution: "Altersverteilung",
    chartOfGender: (chart: string) => `${chart} nach Geschlecht`,
    patientCountsByGender: "Patientenzahlen nach Geschlecht",
    totalPatients: "Patienten gesamt",
    meanField: (field: string) => `Mittelwert ${field}`,
    formStats: (form: string) => `${form} Statistiken`,
    tableOf: (dataset: string) => `Tabelle: ${dataset}`,
    sparkChartsOf: (form: string) => `Spark-Diagramme von ${form}`,
    statsTableOf: (form: string) => `Statistiktabelle · ${form}`,
    statsTableByTimepoint: (form: string) => `Statistiktabelle · ${form} nach Zeitpunkt`,
    statsTableSparkOf: (form: string) => `Statistiktabelle + Spark-Diagramm · ${form}`,
    statsTableSparkByTimepoint: (form: string) => `Statistiktabelle + Spark-Diagramm · ${form} nach Zeitpunkt`,
    lineChartOverTime: (form: string) => `Liniendiagramm von ${form} über die Zeit`,
    byTimepoint: (form: string) => `${form} nach Zeitpunkt`,
    histogramOf: (subject: string) => `Histogramm von ${subject}`,
    outliersOf: (subject: string) => `Ausreißer in ${subject}`,
    ageOutliers: "Ausreißer beim Alter",
    outlierChart: {
        allPatients: "Alle Patienten",
        noOutliers: "Keine Werte außerhalb der Grenzen.",
        rule: "Punkte mehr als 1,5 × IQR außerhalb der Box werden markiert. Die Box umfasst die mittlere Hälfte der Antworten, die Linie ist der Median.",
        flagged: (count: number) => `${count} markiert`,
        patient: "Patient",
        timepoint: "Zeitpunkt",
        value: "Wert",
        range: "Erwarteter Bereich",
        more: (count: number) => `und ${count} weitere`,
        between: (low: string, high: string) => `${low} bis ${high}`,
        organisation: "Organisation",
        createdBy: "Erstellt von",
        startDate: "Tagebuchbeginn",
        private: "Privat",
        ageYears: (count: number) => `${count} J.`,
        responses: "Antworten",
        mean: "Mittelwert",
        flaggedLabel: "Markiert",
        rangeJoin: "bis",
        tooFew: "Zu wenige Antworten, um Ausreißer zu markieren",
    },
    previousTreatments: (form: string) => `Vorherige Behandlungen · ${form}`,
    patientCountsBy: (group: string) => `Patientenzahlen nach ${group}`,
    barChartOfBy: (subject: string, group: string) => `Balkendiagramm von ${subject} nach ${group}`,
    chartOf: (chart: string, subject: string) => `${chart} von ${subject}`,
    chartOfBy: (chart: string, dataset: string, field: string) => `${chart} von ${dataset} nach ${field}`,
    bySuffix: (title: string, split: string) => `${title} nach ${split}`,
    changeFromBaselineSubject: (subject: string) => `Änderung gegenüber Baseline · ${subject}`,
    lsmeanChange: (subject: string) => `LSMean-Änderung · ${subject}`,
    percentOfMax: (subject: string) => `% vom Maximum · ${subject}`,
    percentChangeFromBaseline: (subject: string) => `% Änderung gegenüber Baseline · ${subject}`,
    score: "Wert",
    shiftRight: "Nach rechts",
    rename: actionCopyDe.rename,
    duplicate: actionCopyDe.duplicate,
    share: actionCopyDe.share,
    delete: actionCopyDe.delete,
    cancel: actionCopyDe.cancel,
    addView: "Ansicht hinzufügen",
    addViewDescription: "Wählen Sie zuerst eine Diagrammansicht oder eine Rohdaten-Tabelle.",
    addViewStepOf: (step: number, total: number) => `Schritt ${step} von ${total}`,
    addViewStepTypeTitle: "Welche Art von Ansicht?",
    addViewStepTypeDescription:
        "Wählen Sie eine Diagrammansicht oder eine Rohdaten-Tabelle. Einstellungen kopieren und KI folgen im nächsten Schritt.",
    addViewStepSetupTitle: "Einstellungen kopieren oder KI fragen",
    addViewStepSetupDescription:
        "Optional. Filter von einem anderen Tab kopieren, beschreiben, was Sie wollen, oder beides.",
    addViewBack: "Zurück",
    addViewAiLabel: "KI fragen",
    addViewAiPlaceholderCharts: "Optional: beschreiben Sie die Diagramme, z. B. WOMAC im Zeitverlauf nach Alter",
    addViewAiPlaceholderData: "Optional: beschreiben Sie Filter, z. B. Knie-Tagebücher für Patienten über 60",
    copySettingsFrom: "Einstellungen kopieren von",
    none: actionCopyDe.none,
    charts: "Diagramme",
    data: "Daten",
    chartsDescription: "Widgets, Trends und Kennzahlen",
    dataDescription: "Tabelle mit Patientenzeilen und Werten",
    createChartsView: "Diagrammansicht erstellen",
    createDataView: "Datenansicht erstellen",
    refreshAria: "Analysedaten aktualisieren",
    addWidget: "Widget hinzufügen",
    addWidgetFor: (name: string) => `Wählen Sie einen Fragebogen, optional ein Feld und die Darstellung für „${name}“.`,
    noWidgetsOnTab: "Noch keine Widgets auf diesem Tab.",
    useAddWidgetToChart: (label: string) =>
        `Nutzen Sie oben „Widget hinzufügen“, um echte ${label}-Daten darzustellen.`,
    diaryFallback: "Tagebuch",
    failedToLoadAnalytics: "Analysedaten konnten nicht geladen werden",
    failedToLoadData: "Daten konnten nicht geladen werden",
    failedToLoadPatientData: "Patientendaten konnten nicht geladen werden. Aktualisieren Sie die Seite.",
    loadingPatients: "Patienten werden geladen...",
    loadingAnalytics: (label: string) => `${label}-Daten werden geladen...`,
    analyticsFallback: "Analysen",
    fieldFallback: "Feld",
    /** Under the total in the middle of a form donut. */
    donutResponses: "Antworten",
    noWidgetsYet: "Noch keine Widgets. Fügen Sie eines aus der Palette hinzu oder fragen Sie den KI-Assistenten.",
    noWidgetsConfigured: "Für diese Ansicht sind keine Widgets konfiguriert.",
    clearFilters: "Filter löschen",
    deleteViewTitle: "Ansicht löschen?",
    deleteViewDescription: (name: string) =>
        `„${name}“ und die zugehörigen Widgets werden dauerhaft entfernt. Das kann nicht rückgängig gemacht werden.`,
    showingRangeOf: (start: string, end: string, total: string, noun: string) => `${start}-${end} von ${total} ${noun}`,
    rowSingular: "Zeile",
    rowPlural: "Zeilen",
    diarySingular: "Tagebuch",
    diaryPlural: "Tagebücher",
    noPatientsMatch: (query: string) => `Keine Patienten passen zu „${query}“`,
    noPatientsMatchFilters: "Keine Patienten passen zu den aktuellen Filtern",
    searchColumnsPlaceholder: "Spalten suchen...",
    searchColumnsAria: "Spalten suchen",
    visibleColumns: "Sichtbare Spalten",
    showAll: "Alle anzeigen",
    hideAll: "Alle ausblenden",
    eventsCount: "Ereignisse",
    acrossDiaries: (count: number) => `Über ${count} ${count === 1 ? "Tagebuch" : "Tagebücher"}`,
    eventPrefix: (label: string) => `Ereignis · ${label}`,
    chartSettings: "Diagrammeinstellungen",
    severalDataTabsHint:
        "Sie haben bereits mehrere Daten-Tabs - passen Sie Filter oder Spalten auf einem vorhandenen Tab an.",
    chartN: (n: number) => `Diagramm ${n}`,
    dataN: (n: number) => `Daten ${n}`,
    showingColumnsOf: (visible: string, total: string) => `${visible} von ${total} Spalten`,
    noColumnsMatch: (query: string) => `Keine Spalten passen zu „${query}“`,
    filterCategories: {
        mine: "Meine Rolle",
        demographic: "Demografie",
        label: "Tagebuch-Label",
        org: "Organisation",
        form: "Fragebogen",
        event: "Ereignis",
        status: "Tagebuchstatus",
    },
    filterAnnotations: {
        mine: "Tagebücher, bei denen Sie eine dieser Rollen haben.",
        label: "Tagebücher mit einem dieser Labels.",
        org: "Tagebücher in einer dieser Organisationen.",
        status: "Tagebücher mit einem dieser Status.",
    },
    filteredBy: "Gefiltert nach",
    sexValues: { Female: "Weiblich", Male: "Männlich", Other: "Unbekannt" },
    rawCellExplanations: {
        genderInferred:
            "Das Geschlecht wird aus der Anrede im Patientennamen abgeleitet (z. B. Herr, Frau). Bearbeiten Sie die Spalte Name, um es zu ändern.",
        genderPrivate:
            "Das Geschlecht ist ein aus der Anrede (z. B. Herr, Frau) abgeleitetes Kohortenmerkmal. Der Name bleibt für Ihre Zugriffsstufe privat.",
        patientNamePrivate: "Der Patientenname ist für Ihre Zugriffsstufe privat.",
        patientNameHidden: "Der Patientenname ist ohne Zugriff auf identifizierbare Daten ausgeblendet.",
        dobPrivate: "Das Geburtsdatum ist für Ihre Zugriffsstufe privat.",
        ageEditable:
            "Alter zum Startdatum des Tagebuchs, berechnet aus dem Geburtsdatum – nicht das heutige Alter. Bearbeiten Sie das Geburtsdatum, um es zu ändern.",
        agePrivate:
            "Alter zum Startdatum des Tagebuchs, berechnet aus dem Geburtsdatum – nicht das heutige Alter. Das Geburtsdatum bleibt für Ihre Zugriffsstufe privat.",
        ageReadonly: "Alter zum Startdatum des Tagebuchs, berechnet aus dem Geburtsdatum – nicht das heutige Alter.",
        sideDerived:
            "Welche Seite die Fragebögen in dieser Zeile betreffen. Wählen Sie beide, wenn beide Seiten betroffen sind.",
        noQuestionnaireSide: "In dieser Zeile gibt es keinen Fragebogen, für den eine Seite gesetzt werden kann.",
        noEditableEvent: "In diesem Tagebuch gibt es kein bearbeitbares Ereignis.",
        unsupportedEventValue: "Dieser Wert wird vom Bearbeitungsformular des Ereignisses nicht unterstützt.",
        noEventDate: "In diesem Tagebuch gibt es kein bearbeitbares Ereignisdatum.",
        noEditableArea: "Kein bearbeitbares Ereignis liefert diesen Bereich.",
        shockwaveProcedure: "Stoßwelle ist die Behandlungsart und kein bearbeitbares Detail.",
        noEditableProcedure: "Kein bearbeitbares Ereignis liefert diese Behandlung.",
        ageDerived: "Alter zum Startdatum des Tagebuchs, berechnet aus dem Geburtsdatum. Nicht das aktuelle Alter.",
        durationDerived: "Berechnet vom Startdatum des Tagebuchs bis heute.",
        ageAtEventDerived: (event: string) => `Berechnet aus dem Geburtsdatum und dem frühesten Datum für ${event}.`,
        noTracker: "Zu diesem Zeitpunkt gibt es für dieses Tagebuch keinen Fragebogen.",
        noSideTracker: (side: string) => `Zu diesem Zeitpunkt gibt es für dieses Tagebuch keinen Fragebogen (${side}).`,
        notOnSchedule: "Dieser Zeitpunkt ist nicht im Zeitplan dieses Fragebogens enthalten.",
        editFromDiary: "Diese Antwort im Patiententagebuch bearbeiten.",
        notOnSideSchedule: (side: string) =>
            `Dieser Zeitpunkt ist nicht im Zeitplan des Fragebogens (${side}) enthalten.`,
        multipleEventRows: (event: string) =>
            `Dieses Ereignis (${event}) hat mehrere Detailzeilen. Bearbeiten Sie es im Patiententagebuch, damit andere Details nicht ersetzt werden.`,
        multipleEvents: (event: string) =>
            `Mehrere Ereignisse (${event}) tragen zu dieser Zelle bei. Bearbeiten Sie sie im Patiententagebuch.`,
        multipleDates: (event: string) =>
            `Mehrere Datumsangaben (${event}) tragen zu dieser Zelle bei. Bearbeiten Sie sie im Patiententagebuch.`,
        editDobHelper: "Das Alter bei Tagebuchbeginn wird aus diesem Geburtsdatum berechnet.",
        editEventDateHelper: (event: string) => `Bearbeiten Sie das Datum für ${event}.`,
    },
    eventDatasetLabels: {
        injection: "Injektionen",
        surgery: "Operationen",
        shockwave: "Stoßwellenbehandlungen",
        product: "Produkte",
        education: "Beratungen",
        medication: "Medikationen",
    } as Record<string, string>,
    rawSideValues: { left: "links", right: "rechts", both: "beidseitig", middle: "mittig" } as Record<string, string>,
    showDetailsAria: "Details anzeigen",
    widgetTypes: {
        stat: "Statistikkarte",
        bar: "Balken",
        histogram: "Histogramm",
        outliers: "Ausreißer",
        donut: "Ring",
        pie: "Kreis",
        line: "Linie/Fläche",
        spark: "Spark-Diagramme",
        statsTable: "Statistiktabelle",
        statsTableSpark: "Statistiktabelle + Spark-Diagramm",
        diaryStatus: "Tagebuchstatus",
        timepoints: "Zeitpunkt-Tabelle",
        table: "Tabelle",
        enrolment: "Kumulative Einschreibung",
        engagement: "Nachbeobachtungs-Vollständigkeit",
        engagementTable: "Nachbeobachtungstabelle",
        engagementRate: "Unter den Begonnenen",
        engagementDisposition: "Patientenverlauf",
        engagementTiming: "Zeitpunkt im Vergleich zum Plan",
        engagementRetention: "Retentionskurve",
        engagementKpi: "Kennzahlen",
        engagementHeatmap: "Heatmap nach Aufteilung",
        engagementDots: "Punktdiagramm",
    },
    valueTransforms: {
        absolute: "Absolut",
        changeFromBaseline: "Änderung gegenüber Baseline",
        lsmeanChange: "LSMean-Änderung",
        percentOfMax: "% vom Maximum",
        percentChangeFromBaseline: "% Änderung gegenüber Baseline",
    },
    summaryTable: {
        unknownForm: "Unbekannter Fragebogen",
        noEntries: "Keine Einträge",
        metric: "Kennzahl",
        distribution: "Verteilung",
        boxPlot: "Boxplot",
        mean: "Mittelwert",
        median: "Median",
        mode: "Modus",
        sd: "SD",
        ci: "95%-KI",
        frequency: "Häufigkeit",
        value: "Wert",
        count: "Anzahl",
        percent: "%",
        indicator: "Indikator",
        proportion: "Anteil",
        entries: "Einträge",
        yes: "Ja",
        no: "Nein",
    },
    rawColumnGroups: {
        Patient: "PATIENT",
        INJECTION: "INJEKTION",
        SURGERY: "OPERATION",
        SHOCKWAVE: "STOSSWELLE",
        PRODUCT: "PRODUKT",
        CONSULTATION: "BERATUNG",
    } as Record<string, string>,
    rawFieldLabels: {
        Date: "Datum",
        Substance: "Substanz",
        Area: "Bereich",
        Site: "Stelle",
        Side: "Seite",
        Dose: "Dosis",
        Type: "Typ",
        Procedure: "Eingriff",
        Product: "Produkt",
        Topic: "Thema",
        "Provided by": "Bereitgestellt von",
        "Delivered by": "Durchgeführt von",
        "Referring clinician": "Überweisende Fachkraft",
        "Injecting clinician": "Injizierende Fachkraft",
        "Operating clinician": "Operierende Fachkraft",
        "Shockwaving clinician": "Behandelnde Fachkraft",
    } as Record<string, string>,
    rawColumnLabels: {
        diary_id: "Tagebuch-ID",
        patient_name: "Name",
        date_of_birth: "Geburtsdatum",
        age: "Alter bei Beginn",
        gender: "Geschlecht",
        organisation: "Organisation",
        side: "Seite",
        area: "Bereich",
        procedure: "Behandlung",
    } as Record<string, string>,
    scoreUnavailable: "Nicht verfügbar",
    scoreAdd: "Wert hinzufügen",
    scoreNotDueYet: "Noch nicht fällig",
    scoreLate: "Verspätet",
    scoreClickToAddTooltip: "Klicken Sie auf die Zelle, um einen Wert hinzuzufügen",
    scoreLateTooltip: "Dieser Zeitpunkt ist überfällig. Klicken Sie auf die Zelle, um einen Wert hinzuzufügen.",
    scoreNotDueTooltip:
        "Dieser Zeitpunkt ist noch nicht fällig. Klicken Sie auf die Zelle, um einen Wert hinzuzufügen.",
    scoreNoTrackerTooltip: "Kein Fragebogen zu diesem Zeitpunkt für dieses Tagebuch.",
    editScore: "Wert bearbeiten",
    clearScore: "Leeren",
    decreaseScoreAria: "Wert verringern",
    increaseScoreAria: "Wert erhöhen",
    scoreRange: (min: number, max: number) => `Bereich ${min} - ${max}`,
    scoreMin: (min: number) => `Min. ${min}`,
    scoreMax: (max: number) => `Max. ${max}`,
    confidential: "Vertraulich",
    confidentialAria: "Vertrauliche Patientendaten. Grund anzeigen.",
    thisTimepoint: "Dieser Zeitpunkt",
    dueDate: (date: string) => `Fällig ${date}`,
    enteredDate: (date: string) => `Eingetragen ${date}`,
    entryNotEnteredYet: "Noch nicht eingetragen",
    timepointHasRecordedScore: (point: string) => `${point} hat einen erfassten Wert.`,
    timepointDates: (point: string, dates: string) => `${point}: ${dates}.`,
    timepointNoTracker: (point: string) =>
        `${point} hat keinen Fragebogen für dieses Tagebuch, ein Wert kann nicht hinzugefügt werden.`,
    clickToAddScore: "Klicken, um einen Wert hinzuzufügen.",
    diaryStatus: "Tagebuchstatus",
    diaryStatusTable: {
        searchPlaceholder: "Nach Patientenname suchen",
        searchAria: "Patienten suchen",
        clearSearch: "Suche löschen",
        columns: "Spalten",
        columnsDescription:
            "Wählen Sie, welche Spalten angezeigt werden. Mit dem Schalter einer Gruppe blenden Sie alle Spalten darin ein oder aus. Name und Geburtsdatum bleiben ausgeblendet, bis Sie sie einschalten.",
        sparkline: "Sparkline",
        patientDetails: "Patientenangaben",
        reset: "Zurücksetzen",
        save: "Speichern",
        questionnaire: "Fragebogen",
        patient: "Patient",
        patientName: "Patientenname",
        dateOfBirth: "Geburtsdatum",
        score: "Verlauf",
        status: "Status",
        startDate: "Startdatum",
        organisation: "Organisation",
        labels: "Kennzeichnungen",
        age: "Alter",
        sex: "Geschlecht",
        area: "Bereich",
        procedure: "Eingriff",
        noPatients: "Keine Patienten entsprechen diesen Filtern.",
        loading: "Patienten werden geladen…",
        unknownPatient: "Unbekannter Patient",
        showing: (from: string, to: string, total: string): string => `${from}-${to} von ${total}`,
    },
};
